type PrivacyStatusNoticesProps = {
  error: string
  notice: string
  refreshing: boolean
  refreshingLabel: string
}

export const PrivacyStatusNotices = ({
  error,
  notice,
  refreshing,
  refreshingLabel,
}: PrivacyStatusNoticesProps) => (
  <>
    {error ? (
      <div className="ca-theme-transition rounded-2xl border border-(--color-status-error-border) bg-(--color-status-error-bg) px-4 py-3 text-sm text-(--color-status-error)">
        {error}
      </div>
    ) : null}
    {notice ? (
      <div className="ca-theme-transition rounded-2xl border border-(--color-status-success-border) bg-(--color-status-success-bg) px-4 py-3 text-sm text-(--color-status-success)">
        {notice}
      </div>
    ) : null}
    {refreshing ? (
      <div className="ca-card-shell ca-theme-transition rounded-2xl px-4 py-3 text-sm text-(--color-text-secondary)">
        {refreshingLabel}
      </div>
    ) : null}
  </>
)
